/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_CoachInputs */

const fr_vehicle_type_coach = /** @type {(inputs: Vehicle_Type_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Car`)
};

const en_vehicle_type_coach = /** @type {(inputs: Vehicle_Type_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

/**
* | output |
* | --- |
* | "Coach" |
*
* @param {Vehicle_Type_CoachInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_coach = /** @type {((inputs?: Vehicle_Type_CoachInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_CoachInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_type_coach(inputs)
	return en_vehicle_type_coach(inputs)
});